import React from 'react';

import Container from './Container';
import Notice from './Notice';

export default ({ children }) => (
  <Container>
    <div>${children}</div>
    <Notice>This is what you will be paid once the transaction has completed.</Notice>
  </Container>
);
